// Vue
import { Component, Prop, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ModuleList } from "#/components/module_list/ModuleList";
// Services
import { Api } from "#/api";
import { DashboardTile } from "@mgs/ci2019-common/src/interfaces/DashboardTile";
import * as lunr from "lunr";
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";
import { Observer } from "mobx-vue";
import { Store } from "../../../store";
interface RequestAccessForm {
  spartenId: number | null;
  freigeberId: number | null;
  reason: string;
}

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModuleList,
  },
})
export class PfDashboardModule extends ModuleBase {
  @Prop({ default: false })
  public favoritesOnly!: boolean;

  private currentRequestAccessTile: DashboardTile | null = null;
  private currentRequestAccessForm: RequestAccessForm | null = null;
  private requestAccessTileDialogVisible: boolean = false;
  private requestAccessResult: string | null = null;
  private readonly http: HttpService = HttpService.instance;
  private isLoading = false;
  private favoritesLimit: number = 4;
  private emptyFavorites: number = 0;
  private favoriteOverlayOpen = null;

  private onRequestAccessFormSparteChanged(sparte) {
    if (
      this.currentRequestAccessForm &&
      this.currentRequestAccessForm.freigeberId
    ) {
      let ids = this.getFreigeberForSparte(sparte).map((f) => f.id);
      if (ids.indexOf(this.currentRequestAccessForm.freigeberId) < 0) {
        this.currentRequestAccessForm.freigeberId = null;
      }
    }
  }

  get freigeberForRequestAccessForm() {
    if (
      this.currentRequestAccessTile &&
      this.currentRequestAccessTile.application_access &&
      this.currentRequestAccessForm
    ) {
      return this.getFreigeberForSparte(
        this.currentRequestAccessForm.spartenId
      );
    } else {
      return [];
    }
  }

  private getFreigeberForSparte(sparte) {
    if (
      this.currentRequestAccessTile &&
      this.currentRequestAccessTile.application_access &&
      this.currentRequestAccessForm
    ) {
      let freigeber =
        this.currentRequestAccessTile.application_access.freigeber;

      return freigeber.filter((freigeber) => {
        return (
          freigeber.sparten_ids.filter((value) => value == sparte).length > 0
        );
      });
    } else {
      return [];
    }
  }

  private onOpenRequestAccessDialog(tile: DashboardTile) {
    this.currentRequestAccessTile = tile;
    this.currentRequestAccessForm = {
      spartenId: null,
      freigeberId: null,
      reason: "",
    };
    this.requestAccessTileDialogVisible = true;
  }

  private onCloseRequestAccessDialog() {
    this.requestAccessResult = null;
    this.requestAccessTileDialogVisible = false;
    this.currentRequestAccessForm = null;
    this.currentRequestAccessTile = null;
  }

  private async onSubmitRequestAccessDialog() {
    const isValid = await this.$validator.validateAll(
      "currentRequestAccessTile"
    );
    if (
      isValid &&
      this.currentRequestAccessTile &&
      this.currentRequestAccessForm
    ) {
      try {
        await Api.identity.freigabeBeantragen(
          this.currentRequestAccessTile.kachel["application_id"],
          this.currentRequestAccessForm.freigeberId!,
          this.currentRequestAccessForm.spartenId!,
          this.currentRequestAccessForm.reason
        );

        // Update tile data
        this.getTiles();
        this.currentRequestAccessForm = null;
        this.requestAccessResult = "success";
      } catch (e) {
        this.requestAccessResult = "error";
      }
    }
  }

  private sparten = [
    {
      id: "46",
      key: "truck",
      icon: "dashboard_search_lkw",
      iconFile: "app",
      selected: false,
      title: () => {
        return this.instance["translation"]
          ? this.instance["translation"]["sparte_lkw"]
          : "";
      },
    },
    {
      id: "48",
      icon: "dashboard_search_transporter",
      key: "van",
      iconFile: "app",
      selected: false,
      title: () => {
        return this.instance["translation"]
          ? this.instance["translation"]["sparte_transporter"]
          : "";
      },
    },
    {
      id: "1690",
      icon: "dashboard_search_unimog",
      key: "unimog",
      iconFile: "app",
      selected: false,
      title: () => {
        return this.instance["translation"]
          ? this.instance["translation"]["sparte_special_trucks"]
          : "";
      },
    },
    {
      id: "53",
      icon: "dashboard_search_car",
      key: "pkw",
      iconFile: "app",
      selected: false,
      title: () => {
        return this.instance["translation"]
          ? this.instance["translation"]["sparte_pkw"]
          : "";
      },
    },
  ];

  get aktiveSparten() {
    if (!("sparten" in this.instance)) {
      return this.sparten;
    }

    if (
      Array.isArray(this.instance["sparten"]) &&
      this.instance["sparten"].length <= 1
    ) {
      return [];
    }

    return this.sparten.filter((x) => {
      return this.instance["sparten"].indexOf(x.key) >= 0;
    });
  }

  public tiles: Array<any> = [];

  private searchQuery: string = "";

  public created() {
    let filter = window.localStorage.getItem("pf-dashboard-module-filter");
    if (filter) {
      filter = JSON.parse(filter);
      if (filter && filter["selectedSparten"]) {
        filter["selectedSparten"].forEach((s) => {
          this.setSparteActive(s.id, s.selected);
        });
      }
    }

    this.getTiles();
  }

  public mounted() {
    this.$eventBus.$on("cms.favorites.added", this.favoritesAdded);
    this.$eventBus.$on("cms.favorites.removed", this.favoritesRemoved);
  }

  public beforeDestroy() {
    this.$eventBus.$off("cms.favorites.added", this.favoritesAdded);
    this.$eventBus.$off("cms.favorites.removed", this.favoritesRemoved);
  }

  private async favoritesAdded(tileId) {
    let t = this.tiles.find((t) => t.id == tileId);
    if (t) {
      t["isFavorite"] = true;
    }
  }

  private async favoritesRemoved(tileId) {
    let t = this.tiles.find((t) => t.id == tileId);
    if (t) {
      t["isFavorite"] = false;
    }
  }

  get kachelIds() {
    return this.instance["kacheln"].map((entry) => {
      return entry["kachel_id"];
    });
  }

  get tileHeight() {
    return this.instance["tile_size"] == "small" ? 200 : 280;
  }

  get showTileImage() {
    return this.instance["tile_size"] == "small" ? false : true;
  }

  get filterStorageObject() {
    return {
      searchQuery: this.searchQuery,
      selectedSparten: this.sparten.map((sparte) => {
        return {
          id: sparte.id,
          selected: sparte.selected,
        };
      }),
    };
  }

  @Watch("filterStorageObject")
  private onFilterStorageObjectUpdating() {
    window.localStorage.setItem(
      "pf-dashboard-module-filter",
      JSON.stringify(this.filterStorageObject)
    );
  }

  get lunrIndex() {
    let documents = this.visibleTiles.map((tile) => {
      return {
        id: tile.id,
        title:
          tile.preview && tile.preview.content
            ? tile.preview.content.title
            : "",
        text:
          tile.preview && tile.preview.content ? tile.preview.content.text : "",
        keywords:
          tile.preview && tile.preview.content
            ? tile.preview.content.common_options.search
            : "",
      };
    });
    // @ts-ignore
    return lunr(function () {
      // @ts-ignore
      this.searchPipeline.remove(lunr.stemmer);
      // @ts-ignore
      this.pipeline.remove(lunr.trimmer);
      // @ts-ignore
      this.pipeline.remove(lunr.stemmer);
      // @ts-ignore
      this.pipeline.remove(lunr.stopWordFilter);
      // @ts-ignore
      this.pipeline.add(function (token) {
        token.update(function (t) {
          // strip HTML
          var div = document.createElement("div");
          div.innerHTML = t;
          return div.textContent || div.innerText || "";
        });

        return token;
      });
      // @ts-ignore
      this.pipeline.add(function (token) {
        let result: any[] = [];
        for (var i = 2; i < token.toString().length; i++) {
          let newToken = token.clone().update(function (t) {
            return t.substr(0, i);
          });
          result.push(newToken);
        }
        result.push(token);
        return result;
      });

      // @ts-ignore
      this.ref("id");
      // @ts-ignore
      this.field("title");
      // @ts-ignore
      this.field("text");
      // @ts-ignore
      this.field("keywords");

      documents.forEach((doc) => {
        // @ts-ignore
        this.add(doc);
      });
    });
  }

  get selectedSpartenIds() {
    return this.sparten
      .filter((sparte) => {
        return sparte.selected;
      })
      .map((sparte) => {
        return sparte.id;
      });
  }

  get availableSparten() {
    return this.visibleTiles.flatMap((tile) => {
      return tile["kachel"]["sparten"];
    });
  }

  public async getTiles() {
    if (this.$store.page.page) {
      this.isLoading = true;
      let loadTiles = this.kachelIds,
        tiles = <Array<DashboardTile>>[];

      if (loadTiles.length) {
        tiles = await Api.dashboardService.getTiles(
          this.$store.page.page.portal.id,
          loadTiles,
          this.$store.page.isInEditMode
        );
        for (let i = 0; i < tiles.length; i++) {
          tiles[i]["dialogVisible"] = false;
          tiles[i]["requestAccessDialogVisible"] = false;
          if (
            tiles[i]["preview"]["language"] &&
            tiles[i]["preview"]["content"]["image"]
          ) {
            tiles[i]["preview"]["content"]["image"] = this.addS3Url(
              tiles[i]["preview"]["content"]["image"],
              tiles[i]["preview"]["language"]
            );
          }
        }
      }

      this.isLoading = false;
      this.tiles = tiles;
    }
  }

  private addS3Url(imageObject, language) {
    let languageOrder = [language, "en", "de"];
    for (let index = 0; index < languageOrder.length; ++index) {
      let lang = languageOrder[index];
      if (imageObject[lang]) {
        for (let size in imageObject[lang]) {
          if (
            imageObject[lang][size] &&
            imageObject[lang][size].split("/").length < 6
          ) {
            imageObject[lang][size] =
              Store.instance.page.page!.s3Url + imageObject[lang][size];
          }
        }
      }
    }
    return imageObject;
  }

  get visibleTiles() {
    if (this.instance["kacheln"]) {
      return this.kachelIds
        .map((id) => {
          return this.tiles.find((tile) => tile.id == id);
        })
        .filter((x) => x !== undefined);
    } else {
      return [];
    }
  }

  get searchedTiles() {
    let tiles = this.visibleTiles;

    if (this.searchQuery) {
      tiles = this.lunrIndex.search(this.searchQuery + "~1").map((result) => {
        return this.visibleTiles.find((tile) => tile.id == result.ref);
      });
    }

    return tiles.filter((tile) => {
      let sparten = tile["kachel"]["sparten"];

      if (this.selectedSpartenIds.length > 0) {
        let intersection = this.selectedSpartenIds.filter((sparte) =>
          sparten.includes(sparte)
        );

        return intersection.length > 0;
      } else {
        return true;
      }
    });
  }

  get totalFavorties() {
    return this.tiles.filter((t) => t["isFavorite"]).length;
  }

  public async toggleFavoriteFlag(tile) {
    if (
      tile["isFavorite"] ||
      (!tile["isFavorite"] && this.totalFavorties < this.favoritesLimit)
    ) {
      tile["isFavorite"] = !tile["isFavorite"];

      let url = `${this.$store.ui.appApiUrl}favorites`;

      if (tile["isFavorite"]) {
        await Api.dashboardService.addFavorite(tile["id"]);
        this.$eventBus.$emit("cms.favorites.added", tile["id"]);
        this.$eventBus.$emit("cms.header.show.with-mobile-menu");
        this.$store.ui.activeFlyout = "favorites";
      } else {
        await Api.dashboardService.removeFavorite(tile["id"]);
        this.$eventBus.$emit("cms.favorites.removed", tile["id"]);
        this.$eventBus.$emit("cms.header.show.with-mobile-menu");
        this.$store.ui.activeFlyout = "favorites";
      }
    } else {
      this.favoriteOverlayOpen = tile.id;
    }
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  private toggleSparte(spartenId) {
    for (let i = 0; i < this.sparten.length; i++) {
      if (this.sparten[i].id == spartenId) {
        this.sparten[i].selected = !this.sparten[i].selected;
      }
    }
  }

  private setSparteActive(spartenId, value) {
    for (let i = 0; i < this.sparten.length; i++) {
      if (this.sparten[i].id == spartenId) {
        this.sparten[i].selected = value;
      }
    }
  }

  private isSparteActive(spartenId) {
    for (let i = 0; i < this.sparten.length; i++) {
      if (this.sparten[i].id == spartenId) {
        return this.sparten[i].selected;
      }
    }

    return false;
  }

  private isTileLocked(tile: DashboardTile) {
    return (
      tile.application_access &&
      tile.application_access.access_required &&
      !tile.application_access.user_has_access
    );
  }

  private isAccessRequested(tile: DashboardTile) {
    return (
      tile.application_access &&
      tile.application_access.access_required &&
      tile.application_access.release &&
      tile.application_access.release.in_progress_for_user
    );
  }

  private tileIcon(tile: DashboardTile) {
    if (
      tile.application_access &&
      tile.application_access.access_required &&
      !tile.application_access.user_has_access
    ) {
      return this.$icons.EDIT;
    } else {
      return this.$icons.INFO;
    }
  }

  private hasBack(tile: DashboardTile) {
    return (
      (tile.content && Object.keys(tile.content).length > 0) ||
      (tile.application_access &&
        tile.application_access.access_required &&
        !tile.application_access.user_has_access)
    );
  }

  private isIE() {
    return this.$store.ui.isIE11;
  }

  private closeMobileFavorites() {
    this.$store.ui.activeFlyout = "";
  }

  private handleFavoriteLimitClose(event, tile) {
    this.favoriteOverlayOpen = null;
  }
}
